module.exports = __webpack_public_path__ + "img/Cedar&Elm 960x1080.858e4978.png";